/* ALBEUX: A CALMER HAND-OVER WHEN A PRODUCT PAGE LANDS (2 Nov 2026, Copy of Futuristic).
   From screen recordings: at the moment the sliding page is taken away, the phone fails to draw the header for about 3 frames, and the soft dimming layer behind the slide
   lingers for those frames (the lower part of the page flashed grey).
   1. The sliding page used to start 1 pixel above the bottom of the header (it was measured while the header was in its stuck position, 1 pixel higher than its resting place),
      so once the page was back at the top it overlapped the header by 1 pixel. Now, as the slide is set up, its top edge is put exactly at the header's resting bottom
      (never more than 3 pixels from where it was), so it never overlaps the header.
   2. Once the page has finished sliding in it covers the dimming layer completely, so the dimming layer is taken away right then, while nobody can see it.
   3. When the landing hold ends, any header animation that has just started over is put to its finished state before the screen is drawn.
   4. REVIEWS ON A BAG OPENED FROM "YOU MAY ALSO LIKE": the page that slides in is built into the page after it has loaded, and (unlike the collection slide) nothing told the page
      that new sections had arrived, so the reviews slideshow (swipe + automatic) and the rating count-up never started on those pages. Now, when such a page has landed,
      the same "new section arrived" message that the collection slide already sends is sent, so the reviews turn into the slideshow and the ratings count up as on any other page.
   Only the slide's two layers, animations inside the header, and that one message are touched. To undo: delete the albeux-header-steady.js line in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albHdrSteady) return;
  window.__albHdrSteady = true;
  var d = document.documentElement;
  var wasHold = d.classList.contains('alb-hold');
  var wasZoom = d.classList.contains('alb-zooming');
  var wasLanded = d.classList.contains('alb-landed');

  function inHeader(t) {
    try { return !!(t && t.closest && t.closest('#header-group, header-component, .header-section')); } catch (e) { return false; }
  }

  function calm() {
    var list = [];
    try { list = document.getAnimations ? document.getAnimations() : []; } catch (e) { return; }
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      try {
        if (!('animationName' in a)) continue;
        if (!inHeader(a.effect && a.effect.target)) continue;
        if (a.playState !== 'running' && a.playState !== 'pending') continue;
        var tm = a.effect.getComputedTiming();
        if (tm.iterations === Infinity || tm.endTime === Infinity) continue;
        a.finish();
      } catch (e) {}
    }
  }

  function layers() {
    var kids = document.body.children, wrap = null, dim = null;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.tagName !== 'DIV' || el.style.position !== 'fixed') continue;
      if (el.style.zIndex === '41') wrap = el;
      else if (el.style.zIndex === '40') dim = el;
    }
    return { wrap: wrap, dim: dim };
  }

  /* slide set-up: the sliding page starts exactly at the header's resting bottom */
  function seatLayers() {
    try {
      var L = layers();
      var hc = document.getElementById('header-component');
      if (!L.wrap || !L.dim || !hc) return;
      var H = hc.offsetHeight;
      var old = parseFloat(L.wrap.style.top);
      var diff = H - old;
      if (!(H > 0) || !isFinite(old) || diff < 0.5 || diff > 3) return;
      L.wrap.style.top = H + 'px';
      L.dim.style.top = H + 'px';
    } catch (e) {}
  }

  /* landing: the sliding page (z-index 41) now covers the dimming layer (z-index 40) completely, so the dimming layer goes now */
  function dropDim() {
    try {
      var L = layers();
      if (!L.wrap || !L.dim) return;
      var m = new DOMMatrixReadOnly(getComputedStyle(L.wrap).transform);
      if (Math.abs(m.m41) > 0.5) return;
      L.dim.remove();
    } catch (e) {}
  }

  /* a bag opened from "You may also like" has landed: tell the page that a new section has arrived (the collection slide already does this itself) */
  function announce() {
    try {
      if (!document.querySelector('main[data-alb-base]')) return;
      setTimeout(function () {
        try { document.dispatchEvent(new CustomEvent('shopify:section:load')); } catch (e) {}
      }, 60);
    } catch (e) {}
  }

  try {
    new MutationObserver(function () {
      var hold = d.classList.contains('alb-hold');
      var zoom = d.classList.contains('alb-zooming');
      var landed = d.classList.contains('alb-landed');
      if (!wasZoom && zoom) seatLayers();
      if (!wasHold && hold && zoom) dropDim();
      if (wasHold && !hold) {
        calm();
        requestAnimationFrame(calm);
      }
      if (!wasLanded && landed) announce();
      wasHold = hold;
      wasZoom = zoom;
      wasLanded = landed;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}
})();